module.exports = __webpack_public_path__ + "img/2d8c4c1c4884028cfe043a414fdf27ec.4528c888.png";